import React, { useEffect, useMemo, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Modal,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  CircularProgress,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { PageHeader, SectionCard, EmptyState, TablePager } from "_shared/ui";
import { getScannedDocuments } from "_controllers/officer";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Toaster } from "react-hot-toast";
import { toastMessage } from "utils/toastMessage";
import authAxios from "setups/axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchOfficersList } from "slices/officers";
import SearchIcon from "@mui/icons-material/Search";
import SchemeView from "./SchemeView";
import moment from "moment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import UserSelection from "./UserSelection";
import DownloadIcon from "@mui/icons-material/Download";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import AttachmentIcon from "@mui/icons-material/Attachment";
import axios from "axios";
import { schemeConstants } from "config/constants";
import * as XLSX from "xlsx";
import writeXlsxFile from "write-excel-file";

const messageStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "75%",
  maxHeight: "80vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  textAlign: "center",
};

const Main = () => {
  const dispatch = useDispatch();
  const { officers } = useSelector((state) => state.officers);
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    if (!user?._id) return;
    dispatch(fetchOfficersList(user.SAP_ID));
  }, [user]);

  console.log("officer", officers);

  let updatedUsers = officers?.map((user) => ({
    SAP_ID: user.SAP_ID,
    scanEnabled: user.scanEnabled,
    areaName: user.areaName,
    areaCode: user.areaCode,
    regionName: user.regionName,
    regionCode: user.regionCode,
    name: user?.name,
    zone: user?.zone,
    territoryName: user?.territories[0]?.name,
    territoryCode: user?.territories[0]?.territoryCode,
  }));

  // console.log("updated", JSON.stringify(updatedUsers.slice(-3)));

  const [data, setData] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchUser, setSearchUser] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [image, setImage] = useState("");

  const [schemeData, setSchemeData] = useState();

  const [categories, setCategories] = useState([]);
  const [spendLimit, setSpendLimit] = useState([]);

  const [open, setOpen] = useState(false);
  const [view, setView] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [docListOpen, setDocListOpen] = useState(false);

  const [search, setSearch] = useState("");
  const [role, setRole] = useState("");

  const userType = [
    { value: "SO", name: "Sales Officer" },
    { value: "AO", name: "Area Manager" },
    { value: "RO", name: "Regional Manager" },
    { value: "ZO", name: "Zonal Manager" },
  ];

  let columns = useMemo(() => [
    {
      headerName: "Filled Date",
      flex: 1,
    },
    {
      headerName: "Filled By",
      flex: 1,
    },
    // {
    //   headerName: "Description",
    //   flex: 2,
    // },
    {
      headerName: "#Files",
      flex: 2,
    },
    {
      headerName: "Action",
      flex: 1,
    },
    // {
    //   headerName: "Reconcilation",
    //   flex: 1,
    // },
  ]);

  useEffect(async () => {
    const survey = await getScannedDocuments({
      currentPage,
      searchUser,
    });
    setData(survey?.data);
    setMessage(survey?.message);
    setLoading(true);
    setTotalPages(survey?.totalPage ?? 1);
  }, [message, currentPage, searchUser]);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const [formData, setFormData] = useState([]);

  const handleSubmit = async () => {
    const response = await authAxios()({
      url: `/api/v1/scan/user/access`,
      method: "PUT",
      data: selectedUsers,
    });
    toastMessage(response?.data?.message, "success");
  };

  const handledata = async (data) => {
    const foundObject = updatedUsers.find((obj) => obj.SAP_ID === data.SAP_ID);
    if (foundObject) {
      foundObject.scanEnabled = !foundObject.scanEnabled;
      setSelectedUsers((prev) => {
        let newList = prev.filter((obj) => obj.SAP_ID !== foundObject.SAP_ID);
        if (newList.length === prev.length) {
          newList = [...newList, foundObject];
        }
        return newList;
      });
    }
  };

  const handleViewClose = () => {
    setView(false);
    setDocListOpen(false);
  };

  const handleOpenClose = () => {
    setOpen(false);
  };

  const saveImg = async (e) => {
    setImage(e.target.files[0]);
  };

  const uploadDocument = async (e) => {
    e.preventDefault();
    // if (image.type !== "application/pdf")
    //   return alert("Upload PDF Files Only.");
    const formData = new FormData();
    formData.append("file", image);
    formData.append("fileName", image.name);
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = process.env.REACT_APP_REQUEST_ENDPOINT;
    await axios
      .put(`${url}/api/v1/scan/upload?id=${schemeData?._id}`, formData, config)
      .then((res) => {
        setMessage(res?.data?.message);
        toastMessage(res?.data?.message, "success");
        setUploadModal(false);
      })
      .catch((err) => {
        setImage("");
        setMessage(err?.message);
        toastMessage("Select File First.", "error");
        setUploadModal(false);
      });
  };

  const updatedString = (str) => {
    return Object?.entries(schemeConstants).reduce((acc, [key, value]) => {
      const regex = new RegExp(key, "gi");
      return acc.replace(regex, value);
    }, str);
  };

  const jsonToExcel = (json, name) => {
    console.log("working", JSON.parse(json));
    let fileName = name ? `${name}.xlsx` : "survey.xlsx";
    // const worksheet = XLSX.utils.json_to_sheet(json);
    // const workbook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    // XLSX.writeFile(workbook, "data.xlsx");
    let excelData = [];

    for (const [key, value] of Object.entries(JSON.parse(json))) {
      if (typeof value.Rows === "object") {
        console.log("working2", key, value);
        excelData.push([
          {
            value: value?.Name,
          },
        ]);
        let head = [];
        for (let i = 0; i < value?.Headers.length; i++) {
          head.push({
            value: value?.Headers[i],
          });
        }
        excelData.push(head);
        for (let i = 0; i < value.Rows.length; i++) {
          let ar = [];
          for (let j = 0; j < value.Rows[i].length; j++) {
            ar.push({
              value: value.Rows[i][j],
            });
          }
          excelData.push(ar);
          // console.log("obj", obj)
        }

        // let one = [
        //   {
        //     value: value,
        //   },
        //   {},
        // ];
        // let two = [
        //   {
        //     value: value[0],
        //   },
        //   {
        //     value: value[1],
        //   },
        // ];
        // excelData.push(one);
        // excelData.push(two);
        // value.Rows.forEach((row) => excelData.push(row));
      } else {
        console.log("working1");
        excelData.push([{ value: key }, { value }]);
      }
      console.log("excel Data", excelData);
    }

    console.log("excel", excelData);
    const downloadXlsxFile = () => {
      writeXlsxFile(excelData, {
        fileName: fileName,
      });
    };
    downloadXlsxFile();
  };

  const handleReload = () => {
    setMessage("Survey Updated");
  };

  const downloadAllFiles = async (data) => {
    console.log("daton", data);
    for await (let d of data) {
      await jsonToExcel(d?.document, d?.documentName);
    }
  };
  console.log("view", searchUser);

  console.log("updated", selectedUsers);

  return (
    <>
      {open ? (
        <UserSelection open={open} handleOpenClose={handleOpenClose} />
      ) : (
        <Box>
          <PageHeader
            title="Market Survey Reports"
            subtitle="Scanned survey documents and reconciliation"
            action={
              <Button variant="contained" onClick={() => setOpen(true)}>
                Assign Sales Officer
              </Button>
            }
          />

          <SectionCard sx={{ mb: 3 }}>
            <TextField
              onChange={(e) => setSearchUser(e.target.value)}
              value={searchUser}
              name="searchUser"
              variant="outlined"
              size="small"
              label="Search by SAP ID."
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </SectionCard>

          <SectionCard disablePadding>
            <TableContainer
              sx={{
                maxHeight: "68vh",
                overflowY: "auto",
              }}
            >
              <Table stickyHeader>
                {columns && columns.length > 0 ? (
                  <TableHead>
                    <TableRow>
                      {columns.map((item, idx) => (
                        <TableCell
                          align={idx === 0 ? "left" : "center"}
                          key={idx}
                        >
                          {item.headerName}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                ) : null}

              <TableBody>
                {data && data?.length > 0 ? (
                  data?.map((d) => (
                    <TableRow key={d?._id}>
                      <TableCell align="left">
                        {d?.documents
                          ? moment
                              .utc(d?.documents[0]?.scanDate)
                              .format("YYYY-MM-DD")
                          : "-"}
                      </TableCell>
                      <TableCell align="center">{d?._id ?? "-"}</TableCell>
                      {/* <TableCell align="center">
                        {d?.documentName ? updatedString(d?.documentName) : "-"}
                      </TableCell> */}
                      <TableCell align="center">
                        {d?.documents ? d?.documents?.length : 0}
                      </TableCell>
                      <TableCell align="center">
                        <Button
                          variant="contained"
                          onClick={() => {
                            setDocListOpen(true);
                            setSchemeData(d);
                          }}
                        >
                          {/* <VisibilityIcon
                            sx={{
                              border: "1px solid darkgrey",
                              fontSize: "32px",
                              borderRadius: "3px",
                              cursor: "pointer",
                              padding: "0 5px",
                            }}
                            onClick={() => {
                              setView(true);
                              setSchemeData(d);
                            }}
                          /> */}
                          Details
                        </Button>
                        {/* <Button>
                          <DownloadIcon
                            sx={{
                              border: "1px solid darkgrey",
                              fontSize: "32px",
                              borderRadius: "3px",
                              cursor: "pointer",
                              padding: "0 5px",
                            }}
                            onClick={() => {
                              jsonToExcel(d?.document);
                            }}
                          />
                        </Button> */}
                      </TableCell>
                      {/* <TableCell align="left">
                        <Button>
                          <FileUploadIcon
                            sx={{
                              border: "1px solid darkgrey",
                              fontSize: "32px",
                              borderRadius: "3px",
                              cursor: "pointer",
                              padding: "0 5px",
                            }}
                            onClick={() => {
                              setUploadModal(true);
                              setSchemeData(d);
                            }}
                          />
                        </Button>
                        <Button
                          disabled={
                            d?.uploadedDocument === null ||
                            d?.uploadedDocument === undefined
                              ? true
                              : false
                          }
                        >
                          <a
                            href={d?.uploadedDocument}
                            target="_blank"
                            download
                            style={{
                              textDecoration: "none",
                            }}
                          >
                            <DownloadIcon
                              sx={{
                                border: "1px solid darkgrey",
                                fontSize: "32px",
                                borderRadius: "3px",
                                cursor: "pointer",
                                padding: "0 5px",
                                marginTop: "8px",
                              }}
                            />
                          </a>
                        </Button>
                        <Button>
                          <AttachmentIcon
                            sx={{
                              border: "1px solid darkgrey",
                              fontSize: "32px",
                              borderRadius: "3px",
                              cursor: "pointer",
                              // marginLeft: "1rem",
                              padding: "0 5px",
                            }}
                            onClick={() => {
                              setView(true);
                              setSchemeData(d);
                            }}
                          />
                        </Button>
                      </TableCell> */}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns?.length || 4} sx={{ border: 0 }}>
                      <EmptyState title="No Data" description="No survey reports available." />
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
              </Table>
            </TableContainer>
            <TablePager
              totalPages={totalPages}
              page={currentPage}
              onPageChange={(p) => handlePageChange(null, p)}
            />
          </SectionCard>
          <SchemeView />
        </Box>
      )}

      {view ? (
        <SchemeView
          view={view}
          handleViewClose={handleViewClose}
          data={schemeData}
          handleReload={handleReload}
        />
      ) : null}

      {/* <Modal
        open={open}
        onClose={() => setOpen(false)}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            padding: "1rem",
            width: "75vw",
            height: "80vh",
            overflowY: "scroll",
          }}
        >
          <Typography
            variant="h4"
            sx={{ p: 1 }}
            style={{ textAlign: "center" }}
          >
            List of Users
          </Typography>

          <TextField
            onChange={(e) => setSearchUser(e.target.value)}
            value={searchUser}
            name="searchUser"
            variant="outlined"
            label="Search by SAP ID, area, region, zone."
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <div
            style={{
              display: "grid",
              // margin: "1rem 0 0 3rem",
              padding: "1rem",
              gridTemplateColumns: "auto auto auto",
            }}
          >
            {updatedUsers && updatedUsers?.length > 0 ? (
              updatedUsers
                ?.filter(
                  (r) =>
                    r?.areaName
                      ?.toLowerCase()
                      .includes(searchUser?.toLowerCase()) ||
                    r?.regionName
                      ?.toLowerCase()
                      .includes(searchUser?.toLowerCase()) ||
                    r?.zone
                      ?.toLowerCase()
                      .includes(searchUser?.toLowerCase()) ||
                    r?.name
                      ?.toLowerCase()
                      .includes(searchUser?.toLowerCase()) ||
                    r?.SAP_ID?.toLowerCase().includes(searchUser?.toLowerCase())
                )
                ?.map((r) => (
                  <div key={r.SAP_ID}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            selectedUsers?.find((s) => {
                              return s?.SAP_ID == r?.SAP_ID;
                            }) || r?.scanEnabled === true
                              ? true
                              : false
                          }
                          onChange={(e) => handledata(r)}
                          name={r.name}
                        />
                      }
                      label={`${r?.SAP_ID}- ${r.name}`}
                    />
                  </div>
                ))
            ) : (
              <CircularProgress />
            )}
          </div>
          <Box sx={{ m: 3, display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              onClick={() => {
                setOpen(false);
                setSelectedUsers([]);
              }}
            >
              Close
            </Button>
            <Button variant="contained" onClick={() => handleSubmit()}>
              Submit
            </Button>
          </Box>
        </Box>
      </Modal> */}

      <Modal
        open={uploadModal}
        onClose={() => {
          setUploadModal(false);
        }}
      >
        <Box
          sx={{
            width: "40%",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: "2rem",
            textAlign: "left",
            letterSpacing: 1,
          }}
        >
          <Stack spacing={2}>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Please upload modified survey file.
            </Typography>
            <TextField
              onChange={saveImg}
              InputProps={{
                disableUnderline: true,
              }}
              type={"file"}
              id="standard-basic"
              label="Image"
              name="image"
              variant="standard"
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 1.5,
                mt: 1,
              }}
            >
              <Button
                variant="outlined"
                color="inherit"
                onClick={() => {
                  setUploadModal(false);
                  setImage("");
                }}
              >
                Cancel
              </Button>
              <Button variant="contained" onClick={uploadDocument}>
                Submit
              </Button>
            </Box>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={docListOpen}
        onClose={() => {
          setDocListOpen(false);
        }}
      >
        <Box
          sx={{
            width: "75%",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: "2rem",
            textAlign: "left",
            letterSpacing: 1,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, textAlign: "center" }}
            >
              Survey files uploaded.
            </Typography>
            <IconButton
              onClick={() => setDocListOpen(false)}
              color="error"
              sx={{ position: "absolute", top: 12, right: 16 }}
            >
              <CloseIcon />
            </IconButton>

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 1,
              }}
            >
              <Button
                variant="contained"
                startIcon={<DownloadIcon />}
                onClick={() => downloadAllFiles(schemeData?.documents)}
              >
                Download all files
              </Button>
            </Box>

            <TableContainer
              component={Paper}
              variant="outlined"
              sx={{
                maxHeight: "70vh",
                overflowY: "auto",
                mt: 3,
              }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">S.No</TableCell>
                    <TableCell align="center">File Name</TableCell>
                    <TableCell align="center">Uploaded On</TableCell>
                    <TableCell align="center">Actions</TableCell>
                    <TableCell align="center">Downloaded On</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {schemeData?.documents &&
                  schemeData?.documents?.length > 0 ? (
                    schemeData?.documents?.map((d, idx) => (
                      <TableRow key={d?._id}>
                        <TableCell align="left">{idx + 1}</TableCell>
                        <TableCell align="center">
                          {updatedString(d?.documentName) ?? "-"}
                        </TableCell>
                        <TableCell align="center">
                          {moment.utc(d?.scanDate).format("YYYY-MM-DD") ?? "-"}
                        </TableCell>
                        <TableCell align="center">
                          <Stack
                            direction="row"
                            spacing={1}
                            justifyContent="center"
                          >
                            <Tooltip title="View">
                              <IconButton
                                color="primary"
                                onClick={() => {
                                  setView(true);
                                  setSchemeData(d);
                                }}
                              >
                                <VisibilityIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Download">
                              <IconButton
                                color="primary"
                                onClick={() => {
                                  jsonToExcel(d?.document, d?.documentName);
                                }}
                              >
                                <DownloadIcon />
                              </IconButton>
                            </Tooltip>
                          </Stack>
                        </TableCell>
                        <TableCell align="center">
                          {moment.utc(d?.scanDate).format("YYYY-MM-DD") ?? "-"}
                        </TableCell>
                        {/* <TableCell align="left">
                        <Button>
                          <FileUploadIcon
                            sx={{
                              border: "1px solid darkgrey",
                              fontSize: "32px",
                              borderRadius: "3px",
                              cursor: "pointer",
                              padding: "0 5px",
                            }}
                            onClick={() => {
                              setUploadModal(true);
                              setSchemeData(d);
                            }}
                          />
                        </Button>
                        <Button
                          disabled={
                            d?.uploadedDocument === null ||
                            d?.uploadedDocument === undefined
                              ? true
                              : false
                          }
                        >
                          <a
                            href={d?.uploadedDocument}
                            target="_blank"
                            download
                            style={{
                              textDecoration: "none",
                            }}
                          >
                            <DownloadIcon
                              sx={{
                                border: "1px solid darkgrey",
                                fontSize: "32px",
                                borderRadius: "3px",
                                cursor: "pointer",
                                padding: "0 5px",
                                marginTop: "8px",
                              }}
                            />
                          </a>
                        </Button>
                        <Button>
                          <AttachmentIcon
                            sx={{
                              border: "1px solid darkgrey",
                              fontSize: "32px",
                              borderRadius: "3px",
                              cursor: "pointer",
                              // marginLeft: "1rem",
                              padding: "0 5px",
                            }}
                            onClick={() => {
                              setView(true);
                              setSchemeData(d);
                            }}
                          />
                        </Button>
                      </TableCell> */}
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={5} sx={{ border: 0 }}>
                        <EmptyState title="No Data" description="No files uploaded." />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

const SchemeScanner = () => {
  return (
    <AccessController roles={["ADMIN", "AO"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default SchemeScanner;
